import { Box, Drawer, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

// BottomSheet is a short list a phone picks from, coming up from the bottom edge
export function BottomSheet(props: PropsWithChildren<{
    open: boolean;
    title: string;
    onClose: () => void;
}>) {
    return (
        // a sheet opens from inside a full-screen dialog (see MobileSheet) and can open
        // one of its own, so it sits at the dialogs' level: whichever opened last is on top
        <Drawer anchor="bottom" open={props.open} onClose={props.onClose}
                sx={{ zIndex: theme => theme.zIndex.modal }}
                slotProps={{ paper: { sx: { borderTopLeftRadius: 12, borderTopRightRadius: 12, maxHeight: "70vh" } } }}>
            <Typography variant="caption" color="text.secondary" component="div" sx={{ px: 2, pt: 2, pb: 1 }}>
                {props.title}
            </Typography>
            <Box sx={{ overflow: "auto", pb: "calc(8px + env(safe-area-inset-bottom))" }}>{props.children}</Box>
        </Drawer>
    );
}
